// Action Types

export const NAV_OPEN = "NAV_OPEN";

export const ShowNav = () => ({
  type: NAV_OPEN,
});

const initialState = {
  loading: false,
  navOpen: false,
};

export const NavReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAV_OPEN:
      return { ...state, navOpen: !state.navOpen };

    default:
      return state;
  }
};
